
import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { loginUser, fetchUser } from "../../../store/actions/user";
import { Form, Alert, Button } from "react-bootstrap";
import RegistrationPopup from "../../components/user/registrationPopup";
import logo from "../../assets/images/cms/landing-logo.png";
import LoginForm from "../../components/user/loginForm";

const CmsLogin = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [email_mobile, setEmail_mobile] = useState("");
  const [destination, setDestination] = useState(null);
  const [openRegistration, setOpenRegistration] = useState(false)

  useEffect(() => {
    props.dispatch(fetchUser());
  }, []);

  useEffect(() => {
    if (props.user) {
      window.location.href = "/cms/";
    }
  }, [props.user]);

  useEffect(() => {
    if (props.errorMsg) {
      setOpenRegistration(false)
    }
  }, [props.errorMsg])

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      return false;
    }
    let params = {};
    params.cms_panel=1;
    params.username = username;
    params.password = password;
    setValidated(true);
    props.dispatch(loginUser(params));
  };

  return (
    <div className="container-fluid justify-content-center cms-login-container">
      <div className="row">
        <div className="col-4 col-offset-4">
          <span className="csmlogin-logo">
            <img src={logo} width="260" height="28" alt="logo" />
          </span>
          <div className="cmslogin-form">
            {/* {process.env.REACT_APP_SERVER_ENV == "production" ? (
              <RegistrationPopup
                openRegistration={openRegistration}
                showCloseIcon={false}
                destination={"/cms/"}
                clickLocation={"common_sign_in_popup"}
                iframeUrl={iframeUrl}
              />
            ) :(<Form></Form>)} */}
            <LoginForm
              validated={validated}
              handleSubmit={handleSubmit}
              errorMsg={props.errorMsg}
              username={username}
              setUsername={(obj) => setUsername(obj)}
              password={password}
              setPassword={setPassword}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.userData.user,
    errorMsg: state.userData.login_error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsLogin);
